export default "__VITE_ASSET__msQtvOPF__"